import { render, staticRenderFns } from "./AdminDatasetDetailsPage.vue?vue&type=template&id=49f9d4b7"
import script from "./AdminDatasetDetailsPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./AdminDatasetDetailsPage.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports